import Vue from 'vue';
import Component from 'vue-class-component';
import useFilters from 'composables/useFilters';
import NotificationCircle from 'components/NotificationCircle/NotificationCircle.vue';
import useIsMobile from 'common/composables/useIsMobile.js';

@Component({
  props: {
    option: {
      type: Object,
      required: true,
      description: 'Card name, id, icon and tittle',
    },
    active: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    NotificationCircle,
  },
  setup() {
    const { isDesktop } = useIsMobile();

    const { getCardSelected, getAllResultsCount, setCard } = useFilters();
    return {
      cardSelected: getCardSelected,
      getAllResultsCount,
      setCard,
      isDesktop,
    };
  },
})
export default class CardComponent extends Vue {
  /**
   * Used to show quantity of results from the search
   */

  get results() {
    return this.getAllResultsCount[this.option.id];
  }

  get resultsNotification() {
    if (!this.results) return '';
    return this.results >= 10 ? '+9' : this.results;
  }

  get showSearchResults() {
    return this.results > 0 && !this.cardIsActive;
  }

  get cardIsActive() {
    return this.cardSelected === this.option.id;
  }

  handleCardClick() {
    this.$emit('click', this.index);
    this.setCard(this.option.id);
  }
}
